/* v4.16.0 (Oct 26): fixes from the Clarity review.
   1. Long option lists (the 68 phone models) become one dropdown so the Upload button is not 4 screens down.
   2. A one-line "what happens next" note under the Upload button.
   3. Full-size photo viewer: clear Close button, tap outside the photo closes, hint text tells people how zoom works.
   4. Clarity: how long people stay in the photo tool (buckets), so quick lookers and real failures can be told apart.
   5. Double-add guard: if an Add to cart request fails on a slow connection after the server already took it, the old fallback
      re-sent the form and could put the same photo item in the cart twice. Now the cart is checked first.
   Nothing here changes prices, carts or the photo tool itself. */
(function () {
  var d = document;
  function ev(n) { try { if (typeof window.clarity === 'function') window.clarity('event', n); } catch (e) {} }
  function tag(k, v) { try { if (typeof window.clarity === 'function') window.clarity('set', k, v); } catch (e) {} }
  function qa(s, el) { return Array.prototype.slice.call((el || d).querySelectorAll(s)); }

  /* ---------- 1. long option lists -> dropdown ---------- */
  function brandOf(v) {
    if (/^iphone/i.test(v)) return 'iPhone';
    if (/^google/i.test(v)) return 'Google Pixel';
    if (/^samsung/i.test(v)) return 'Samsung Galaxy';
    return '';
  }
  function dropdownize(fs) {
    if (fs.getAttribute('data-dc-sel')) return;
    var inputs = qa('input[type="radio"]', fs);
    if (inputs.length < 13) return;
    fs.setAttribute('data-dc-sel', '1');
    var legend = fs.querySelector('legend');
    var phone = inputs.some(function (i) { return /iphone|galaxy|pixel/i.test(i.value); });
    var title = phone ? 'Choose your phone' : ((legend && legend.textContent.trim()) || 'Choose');
    if (legend && phone) legend.textContent = 'Your phone model';
    var wrap = d.createElement('div');
    wrap.className = 'dc-v416-sel';
    var sel = d.createElement('select');
    sel.setAttribute('aria-label', title);
    var groups = {}, order = [];
    inputs.forEach(function (inp) {
      var b = brandOf(inp.value);
      if (!(b in groups)) {
        groups[b] = b ? d.createElement('optgroup') : sel;
        if (b) { groups[b].label = b; order.push(b); }
      }
      var o = d.createElement('option');
      o.value = inp.value; o.textContent = inp.value;
      groups[b].appendChild(o);
    });
    order.forEach(function (b) { sel.appendChild(groups[b]); });
    wrap.appendChild(sel);
    var pills = fs.querySelector('.dc-opt__pills');
    if (pills) { pills.parentNode.insertBefore(wrap, pills); fs.classList.add('dc-opt--sel'); }
    else fs.appendChild(wrap);
    function sync() {
      var c = inputs.filter(function (i) { return i.checked; })[0];
      if (c && sel.value !== c.value) sel.value = c.value;
      qa('option', sel).forEach(function (o, n) {
        var lab = inputs[n] && inputs[n].closest('label');
        var base = o.value;
        var out = lab && lab.classList.contains('is-unavailable');
        o.textContent = out ? base + ' (sold out)' : base;
      });
    }
    sel.addEventListener('change', function () {
      var t = inputs.filter(function (i) { return i.value === sel.value; })[0];
      if (!t) return;
      if (!t.checked) t.click();
      ev('phone_dropdown');
    });
    fs.addEventListener('change', function () { setTimeout(sync, 0); });
    sync();
    setTimeout(sync, 400);
  }
  function initOptions() {
    qa('[data-dc-product] fieldset.dc-opt').forEach(dropdownize);
  }

  /* ---------- 2. note under the Upload button ---------- */
  function initNote() {
    var root = d.querySelector('[data-dc-product]');
    if (!root || !root.querySelector('[data-dc-pzhint]')) return;
    var app = root.querySelector('.dc-pdp__app');
    if (!app || !app.parentNode || root.querySelector('[data-dc-v416-note]')) return;
    var cal = /calendar/i.test(location.pathname);
    var p = d.createElement('p');
    p.className = 'dc-v416-note';
    p.setAttribute('data-dc-v416-note', '');
    p.textContent = cal
      ? 'Your photo library opens next. Add a photo for the cover and each month, then tap Continue.'
      : 'Your photo library opens next. Pick one photo, then tap Continue.';
    app.parentNode.insertBefore(p, app.nextSibling);
  }

  /* ---------- 3. full-size viewer ---------- */
  function fixViewer(V) {
    if (V.getAttribute('data-v416')) return;
    V.setAttribute('data-v416', '1');
    var x = V.querySelector('.dc-zv__x');
    if (x) { x.innerHTML = '<span aria-hidden="true">&times;</span> Close'; x.classList.add('dc-zv__x--pill'); }
    var hint = V.querySelector('.dc-zv__bar span');
    var img = V.querySelector('.dc-zv__img');
    function setHint() {
      if (!hint) return;
      var m = /scale\(([0-9.]+)\)/.exec((img && img.style.transform) || '');
      var zoomed = m && parseFloat(m[1]) > 1.05;
      hint.textContent = zoomed ? 'Drag to move. Tap the photo to zoom out.' : 'Tap the photo to zoom. Tap outside it to close.';
    }
    setHint();
    if (img && 'MutationObserver' in window) new MutationObserver(setHint).observe(img, { attributes: true, attributeFilter: ['style'] });
    /* tap on the dark area outside the photo closes the viewer */
    var down = null;
    V.addEventListener('pointerdown', function (e) { down = { t: Date.now(), x: e.clientX, y: e.clientY, tgt: e.target }; }, true);
    V.addEventListener('pointerup', function (e) {
      var s = down; down = null;
      if (!s || e.target !== V || s.tgt !== V) return;
      if (Date.now() - s.t > 450 || Math.abs(e.clientX - s.x) > 8 || Math.abs(e.clientY - s.y) > 8) return;
      ev('viewer_close_outside');
      var b = V.querySelector('.dc-zv__x'); if (b) b.click();
    });
  }
  function watchViewer() {
    var cur = d.querySelector('.dc-zv'); if (cur) fixViewer(cur);
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (list) {
      list.forEach(function (m) {
        qa('.dc-zv', m.target).forEach(fixViewer);
        Array.prototype.forEach.call(m.addedNodes || [], function (n) {
          if (n.nodeType === 1 && n.classList && n.classList.contains('dc-zv')) fixViewer(n);
        });
      });
    }).observe(d.body, { childList: true });
  }

  /* ---------- 4. Clarity: how long in the photo tool ---------- */
  function bucket(s) { return s < 10 ? 'lt10s' : s < 30 ? '10_30s' : s < 60 ? '30_60s' : s < 180 ? '1_3m' : 'gt3m'; }
  var t0 = 0, seenOpen = false, poll = null, applied = false;
  function stopPoll() { if (poll) { clearInterval(poll); poll = null; } }
  function modalOpen() {
    var m = d.querySelector('.personalize-modal');
    if (!m) return false;
    var r = m.getBoundingClientRect();
    var cs = window.getComputedStyle(m);
    return r.width > 0 && r.height > 0 && cs.visibility !== 'hidden' && cs.display !== 'none';
  }
  function startTimer() {
    t0 = Date.now(); seenOpen = false; applied = false; stopPoll();
    var n = 0;
    poll = setInterval(function () {
      n++;
      if (n > 1500) { stopPoll(); return; }
      var o = modalOpen();
      if (o) { seenOpen = true; return; }
      if (seenOpen && !applied) {
        stopPoll();
        var b = bucket((Date.now() - t0) / 1000);
        ev('editor_closed_' + b); tag('editor_closed_after', b);
      }
    }, 700);
  }
  function initTimer() {
    d.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('.personalize-button')) startTimer();
    }, true);
    window.addEventListener('message', function (e) {
      if (String(e.origin).indexOf('personalize.at') < 0) return;
      var m = e.data;
      try { if (typeof m === 'string') m = JSON.parse(m); } catch (x) { return; }
      if (m && m.type === 'PERSONALIZATION_APPLIED' && t0) {
        applied = true; stopPoll();
        var b = bucket((Date.now() - t0) / 1000);
        ev('photo_saved_' + b); tag('photo_saved_after', b);
      }
    });
    /* leaving the page while the tool is open (the phone's photo picker, an app switch) */
    d.addEventListener('visibilitychange', function () {
      if (d.visibilityState === 'hidden' && t0 && modalOpen() && !applied) {
        tag('hidden_in_editor_after', bucket((Date.now() - t0) / 1000));
      }
    });
  }

  /* ---------- 5. double-add guard ---------- */
  function initCartGuard() {
    var f = d.getElementById('dc-product-form');
    if (!f || f.getAttribute('data-v416g') || typeof f.submit !== 'function') return;
    f.setAttribute('data-v416g', '1');
    var orig = f.submit;
    f.submit = function () {
      var self = this;
      function go() { orig.call(self); }
      var pe = self.querySelector('input[name="properties[Personalization ID]"]');
      var pid = pe && pe.value;
      if (!pid) { go(); return; }
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        var dup = (c.items || []).some(function (i) { return i.properties && i.properties['Personalization ID'] === pid; });
        if (dup) { ev('cart_dup_prevented'); location.href = location.pathname + '?cart=open'; } else { go(); }
      }).catch(go);
    };
  }

  function init() {
    try { initCartGuard(); } catch (e) {}
    try { initOptions(); } catch (e) {}
    try { initNote(); } catch (e) {}
    try { watchViewer(); } catch (e) {}
    try { initTimer(); } catch (e) {}
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
